<template>
  <Authentication>
    <div class="auth-layout-form">
      <h4 class="auth-layout-title">تغییر رمز عبور</h4>
      <p class="auth-layout-msg">رمز جدید خود را وارد کنید.</p>
      <b-form @submit.prevent="onSubmit">
        <b-form-group>
          <b-form-input
            @update="passwordChangeHandler"
            type="password"
            :state="this.validationPassword"
            placeholder="رمز عبور"
            v-model="form.password.value"
          ></b-form-input>
          <b-form-invalid-feedback
            class="text-right"
            :state="this.validationPassword"
          >
            {{ form.password.error }}
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group>
          <b-form-input
            @update="confirmPasswordChangeHandler"
            type="password"
            :state="this.validationConfirmPassword"
            placeholder="تکرار رمز عبور"
            v-model="form.confirmPassword.value"
          ></b-form-input>
          <b-form-invalid-feedback
            class="text-right"
            :state="this.validationConfirmPassword"
          >
            {{ form.confirmPassword.error }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group>
          <LoadingBtn
            block
            type="submit"
            variant="primary"
            :disabled="disabled"
            :loading="loader"
          >
            تغییر رمز
          </LoadingBtn>
        </b-form-group>
        <error-messages
          :show="showMessage"
          :dismissible="true"
          @dismissed="dismissedError"
          :messages="alertMessage"
        />
      </b-form>
      <div class="auth-layout-footer">
        <router-link to="/login">ورود</router-link>
        <router-link to="/register">ثبت نام</router-link>
      </div>
    </div>
  </Authentication>
</template>

<script>
import Authentication from "../Authentication";
import LoadingBtn from "@/components/LoadingBtn/LoadingBtn";
import { resetPassword } from "@/services/auth";
import { mapState, mapActions } from "vuex";
import {
  ON_SHOW_LOADER,
  ON_HIDE_LOADER,
  SHOW_MESSAGE,
  HIDE_MESSAGE
} from "@/store/mutation-types";

export default {
  name: "Login",
  components: {
    Authentication,
    LoadingBtn
  },
  data() {
    return {
      form: {
        password: {
          value: "",
          error: ""
        },
        confirmPassword: {
          value: "",
          error: ""
        }
      },
      validationPassword: null,
      validationConfirmPassword: null,
      disabled: true
    };
  },
  computed: {
    ...mapState("auth", ["loader", "alertMessage", "showMessage"])
  },
  methods: {
    ...mapActions("auth", [
      ON_SHOW_LOADER,
      SHOW_MESSAGE,
      HIDE_MESSAGE,
      ON_HIDE_LOADER
    ]),
    dismissedError: function() {
      this[HIDE_MESSAGE]();
    },
    onSubmit: async function() {
      this[ON_SHOW_LOADER]();
      const [error, data] = await resetPassword({
        newPassword: this.form.password.value,
        token: this.$route.params.token
      });
      if (error) this[SHOW_MESSAGE](error);
      else {
        if (data.apiStatus === 200) {
          this[ON_HIDE_LOADER]();
          this.$router.push("/login");
        } else {
          this[SHOW_MESSAGE](data.apiErrors);
        }
      }
    },
    passwordChangeHandler: function(val) {
      const preg = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;
      if (val === "") {
        this.form.password.error = "رمز عبور الزامی است";
        this.validationPassword = false;
      } else {
        if (!preg.test(val)) {
          this.form.password.error =
            "رمز عبور باید شامل حروف کوچک یا بزرگ انگلیسی، حداقل یک عدد، حداقل یک کاراکتر خاص و حداقل 8 کاراکتر باشد.";
          this.validationPassword = false;
        } else {
          this.form.password.error = "";
          this.validationPassword = true;
          if (this.form.password.value !== this.form.confirmPassword.value) {
            this.form.confirmPassword.error =
              "رمز عبور با تکرار رمز عبور مطابقت ندارد.";
            this.validationConfirmPassword = false;
          } else {
            this.form.confirmPassword.error = "";
            this.validationConfirmPassword = true;
          }
        }
      }
    },
    confirmPasswordChangeHandler: function(val) {
      if (val === "") {
        this.form.confirmPassword.error = "تکرار رمز عبور الزامی است";
        this.validationConfirmPassword = false;
      } else {
        if (this.form.password.value !== this.form.confirmPassword.value) {
          this.form.confirmPassword.error =
            "رمز عبور با تکرار رمز عبور مطابقت ندارد.";
          this.validationConfirmPassword = false;
        } else {
          this.form.confirmPassword.error = "";
          this.validationConfirmPassword = true;
        }
      }
    }
  },
  updated() {
    if (this.validationConfirmPassword && this.validationPassword) {
      this.disabled = false;
    } else {
      this.disabled = true;
    }
  }
};
</script>

<style></style>
